/**
 * 미디어 그리드 레이아웃 클래스 결정 함수
 * 아이템 개수와 특성에 따라 CSS 그리드 클래스를 결정
 * 여러 이미지가 있을 때도 항상 사각형 영역을 유지하도록 설계됨
 * 
 * @param media 표시할 미디어 항목 배열
 * @returns 적용할 CSS 그리드 클래스
 */ export var calculateGridClass = function(media) {
    switch(media.length){
        case 1:
            return 'grid-cols-1 aspect-square';
        case 2:
            return 'grid-cols-2 aspect-square';
        case 3:
            // 3개 이미지일 때는 특별한 grid-template-areas 사용
            return 'grid-3-items aspect-square';
        case 4:
            return 'grid-cols-2 aspect-square';
        default:
            return 'grid-cols-2 aspect-square';
    }
};
/**
 * 미디어 아이템 클래스 계산 함수
 * 아이템 타입과 위치에 따라 CSS 클래스를 결정
 * 
 * @param item 미디어 아이템
 * @param index 아이템 인덱스
 * @param media 전체 미디어 배열
 * @returns 적용할 CSS 클래스
 */ export var calculateItemClass = function(item, index, media) {
    var baseClass = 'relative overflow-hidden rounded-lg';
    // 3개의 이미지일 때 첫 번째 이미지는 더 크게 표시
    if (media.length === 3) {
        if (index === 0) {
            baseClass += ' grid-area-a';
        } else if (index === 1) {
            baseClass += ' grid-area-b';
        } else {
            baseClass += ' grid-area-c';
        }
    } else {
        // 일반 정사각형 아이템
        baseClass += ' aspect-square';
    }
    // 비디오의 경우 검은색 배경 추가
    if (item.type === 'video') {
        baseClass += ' bg-black';
    }
    return baseClass;
};
